import { toast } from 'react-toastify';
import * as yup from 'yup';

import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import {
  downloadFileExport,
  formatDate, isEmpty,
  isEmptyObject,
  isSuccess,
} from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { trans } from '../../../localization/index';

export function setExportInfoRestaurant(exportItem) {
  return {
    type: actions.RECEIVE_ITEM_EXPORT_RESTAURANT,
    response: {
      exportItem,
    },
  };
}

export function getListReportRestaurant() {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/report/get_list_reports')
      .then((response) => {
        if (isSuccess(response)) {
          const { reports: itemList = [] } = response.reply;
          dispatch({
            type: actions.RECEIVE_LIST_EXPORT_RESTAURANT,
            response: {
              itemList,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function requestOrderReport() {
  function validate(state, dispatchGeneralError) {
    const { filters } = state;
    const schema = yup.object().shape({
      fromDate: yup
        .date()
        .max(yup.ref('toDate'), trans('mod_from_date_to_date_not_correct'))
        .required(),
      toDate: yup.date().required(),
      restaurant: yup.object().shape({
        value: yup.number().required(),
      }),
    });
    try {
      schema.validateSync(filters);
      return true;
    } catch (err) {
      dispatchGeneralError(err.errors[0]);
      return false;
    }
  }

  function genBody(state) {
    const { filters } = state;
    const { fromDate, toDate, restaurant, timeFilterType } = filters;

    const body = {
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
    };

    if (restaurant.value) {
      body.restaurant_ids = [restaurant.value];
    }

    if (!isEmpty(timeFilterType.value)) {
      body.time_filter_type = timeFilterType.value;
    }

    return body;
  }

  return (dispatch, getState) => {
    const state = getState().report.export;
    if (!validate(state, error => dispatch(setGeneralError(error)))) {
      return null;
    }
    const body = genBody(state);
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/report/request_order_report', body)
      .then((response) => {
        if (isSuccess(response)) {
          toast.info(trans('mod_export_restaurant_process'));
          return dispatch(getListReportRestaurant());
        }
        let nextTimeExport = 0;
        if (!isEmptyObject(response.reply)) {
          const { remaining_seconds: remainingSeconds = 0 } = response.reply;
          nextTimeExport = remainingSeconds;
        }
        dispatch(setGeneralError(trans(response.result, [nextTimeExport])));
        return dispatch(stopAppLoading());
      });
  };
}

export function getUrlExportRestaurant(reportId) {
  return (dispatch) => {
    dispatch(startAppLoading());
    const body = {
      report_ids: [reportId],
    };
    return request
      .postMerchant('/api/report/get_download_urls', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { reports } = response.reply;
          if (!isEmptyObject(reports)) {
            downloadFileExport(reports[0].download_url);
          } else {
            dispatch(setGeneralError(trans('mod_export_url_expired')));
          }
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        return dispatch(stopAppLoading());
      });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ExportRestaurant/actions.js